import { render, staticRenderFns } from "./Circus.vue?vue&type=template&id=3fb34c94&scoped=true&"
import script from "./Circus.vue?vue&type=script&lang=js&"
export * from "./Circus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fb34c94",
  null
  
)

export default component.exports